import { render, staticRenderFns } from "./ScannerInStoreView.vue?vue&type=template&id=60c475e1&lang=pug"
import script from "./ScannerInStoreView.vue?vue&type=script&lang=js"
export * from "./ScannerInStoreView.vue?vue&type=script&lang=js"
import style0 from "./ScannerInStoreView.vue?vue&type=style&index=0&id=60c475e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports